import { isPlatformServer } from '@angular/common';
import { Component, OnInit, Input, PLATFORM_ID, Inject, ElementRef, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { SearchService } from '../../services/search.service';
import { Router } from '@angular/router';
import { IAccordionItemDataModel } from '../../models/accordion-item.datamodel';
import { AssetPipe } from "../../pipes/asset.pipe";

interface BranchesData {
  name: string;
  code: string;
  address: string;
  workinghours?: string;
  lat?: number;
  long?: number;
  url?: string;
}

const keyphraseVariants = new Set([
    // Ελληνικά - κατάστημα
    'κατάστημα','καταστημα','ΚΑΤΑΣΤΗΜΑ','Κατάστημα','Καταστημα',
    'καταστηματα','καταστήματα','ΚΑΤΑΣΤΗΜΑΤΑ','Καταστήματα','Καταστηματα',

    // Συνήθη λάθη/typos
    'καταστιμα','κατάστιμα','καταστιματα','κατάστιματα',

    // Branch (English)
    'branch','Branch','BRANCH',
    'branches','Branches','BRANCHES',
]);
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnChanges {
    @Input() rendering: ComponentRendering;
    @Input() language: string;
    @Input() energySave: boolean;
    @Input() isMobile: boolean;
    _isPlatformServer: boolean = false;
    keyphrase: string;
    suggestions : any []= [];
    searchResults : any []= [];
    searchQAResults : any []= [];
    uuid : string;
    iconBranch : string;
    activeSuggestionIndex: number = -1;
    searchIsFocused : boolean;
    showMoreEnabled : boolean = false;
    noResultsFound : boolean = false;
    cards: IAccordionItemDataModel[] = [];
    branchesData:BranchesData[]=[];
    selectedDisplayedContent :string = "both";

    constructor(private el: ElementRef, @Inject(PLATFORM_ID) public readonly platformId: string, public searchService: SearchService, private router: Router,private cdr : ChangeDetectorRef) { }

    ngOnInit() {
        // remove this after implementation is done
        this._isPlatformServer = isPlatformServer(this.platformId);
        const fields = (this.rendering?.fields as any)?.FAQsModule[0]?.fields;
        const simpleFaqItem = fields?.Cards.filter((item:any) => item?.fields?.Answer !== undefined);
              
        if(fields?.Cards?.length > 0  && simpleFaqItem?.length > 0){ 
            simpleFaqItem.forEach((item:any) => {
                let card:IAccordionItemDataModel = {
                    Answer: item?.fields?.Answer?.value,
                    Question: item?.fields?.Question?.value
                } 
                this.cards.push(card);
            });
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['energySave']) {
            this.iconBranch = this.energySave ? new AssetPipe().transform('images/map/branch-marker-energy.svg') : new AssetPipe().transform('images/map/branch-marker.svg');
        }
        this.cdr.detectChanges();
    }

    closeModal(): void {
        if (!this._isPlatformServer) {
            if (this.el) {
                // this.fadeOut(this.el.nativeElement.querySelector("#pb-search-modal"));
                this.el.nativeElement.querySelector("#pb-search-modal").classList.remove("pb-movedown");
                this.el.nativeElement.querySelector("#pb-search-modal").classList.add("pb-moveup");
                document.querySelector<HTMLElement>("body").classList.remove("pb-overflow-y-hidden");
            }
        }
    }

    fadeOut(element: HTMLElement) {
        if (!this._isPlatformServer) {
            let opacity = 1;
            let duration = 500;
            const interval = 16;
            const decrement = interval / duration;

            function tick() {
                opacity -= decrement;
                element.style.opacity = String(opacity);

                if (opacity <= 0) {
                    element.style.display = "none";
                    clearInterval(timer);
                }
            }

            const timer = setInterval(tick, interval);
        }
    }

    handleArrowDown(event : KeyboardEvent){

        if (!this._isPlatformServer && this.suggestions.length > 0) {
            if (event.key === 'ArrowDown' || event.key === 'Tab') {
                event.preventDefault();
                // Move selection down
                if(this.activeSuggestionIndex == this.suggestions.length - 1){
                    this.activeSuggestionIndex = 0;
                }else{
                    this.activeSuggestionIndex = Math.min(this.activeSuggestionIndex + 1, this.suggestions.length - 1);
                }
                this.keyphrase = this.suggestions[this.activeSuggestionIndex].text;
            }   
        }   
    }

    handleArrowUp(event : KeyboardEvent){

        if (!this._isPlatformServer && this.suggestions.length > 0) {
            if (event.key === 'ArrowUp') {
                event.preventDefault();
                // Move selection up
                if(this.activeSuggestionIndex == -1){
                    this.activeSuggestionIndex = this.suggestions.length - 1;
                }else{
                    this.activeSuggestionIndex = Math.max(this.activeSuggestionIndex - 1, 0);
                }
                this.keyphrase = this.suggestions[this.activeSuggestionIndex].text;
            }
        }
    }

    onKeyboardChange(event: any) {
        if (event.key === "Enter" || event.keyCode === 13) {
            event.target.blur();
            this.search();
        }
    }

    suggestion(){

        if(this.keyphrase.length<3){
            this.suggestions = [];
            return;
        }

        this.activeSuggestionIndex = -1;

        var searchRequest = {
            "query": {
                "keyphrase": this.keyphrase
            },
            "suggestion": [
                {
                    "name": "title_autocomplete"
                }
            ]                            
        };


        this.searchService.search(searchRequest, this.language).then(resp => {
            if (resp.status === 200) {
                if((resp.data as any)?.widgets[0]?.suggestion?.title_autocomplete?.length > 0){
                    this.suggestions = (resp.data as any)?.widgets[0]?.suggestion?.title_autocomplete?.map((suggestion : any) => suggestion);
                }else{
                    this.typoSuggestion();
                }
            }
        });
    }

    search(limit:number=8,offset:number=0){

        if((this.keyphrase.endsWith(";") || this.keyphrase.endsWith("?")) && (this.rendering?.fields as any)?.QAFeature?.value){
            var searchQARequest = {
                "keyphrase": this.keyphrase,
                "related_questions": {
                    "limit": 5
                }
            };
    
            this.searchService.searchQA(searchQARequest, this.language).then(resp => {
                if (resp.status === 200) {
                 if((resp?.data as any)?.widgets[0]?.related_questions?.length > 0){
                    this.searchQAResults = (resp?.data as any)?.widgets[0]?.related_questions;
                 }else{
                    this.searchQAResults=[];
                 }
                }else{
                    this.searchQAResults=[];
                }
              }).finally(() => {
                this.cdr.detectChanges();
    
              });

        }else{
            this.selectedDisplayedContent='both' ;
            var searchRequest = {
                "content": {},
                "personalization": {
                    "fields": [
                        "heading1",
                        "name"
                    ],
                    "algorithm": "affinity"
                },
                "query": {
                    "keyphrase": this.keyphrase
                }, 
                "filter": {
                    "type":"not",
                    "filter": {
                        "name": "type",
                        "type": "eq",
                        "value": "branch"
                    }
                },
                "limit":limit,
                "offset":offset
            };
    
            this.searchService.search(searchRequest, this.language).then(resp => {
                if (resp.status === 200) {
                    this.searchQAResults=[];
                    if((resp.data as any)?.widgets[0]?.content?.length > 0){
                        this.noResultsFound = false;
                        if((resp.data as any)?.widgets[0]?.content?.length <= 8){
                            this.showMoreEnabled = false;
                        }
                        this.suggestions = [];
                        if(offset==0){
                            this.searchResults = (resp.data as any)?.widgets[0]?.content?.map((results : any) => results);
                        }else{
                            this.searchResults = this.searchResults.concat((resp.data as any)?.widgets[0]?.content?.map((results : any) => results));
                        }
                        this.showMoreEnabled = (resp.data as any)?.widgets[0].total_item > this.searchResults.length;
                    }else{
                        this.searchResults = [];
                        this.showMoreEnabled = false;
                        if(!(this.rendering?.fields as any)?.EnableSearchInBranches?.value ){
                            this.noResultsFound = true;
                        }
                    }
                }
            }).finally(() => {
                if((this.rendering?.fields as any)?.EnableSearchInBranches?.value ){
                    this.searchBranches();
                }
                this.cdr.detectChanges();
            });
            
        }

        // FAQ search
        if((this.rendering?.fields as any)?.FaqFeature?.value){
            this.searchService.searchFaq(this.keyphrase, this.language).then(resp => {
                if (resp.status === 200) {
                  this.cards = [];
                  if((resp.data as any)?.widgets[0]?.content?.length > 0){
                    (resp.data as any)?.widgets[0]?.content.forEach((item:any) => {
                        let card:IAccordionItemDataModel = {
                            Answer: item?.answer,
                            Question: item?.name
                        } 
                        this.cards.push(card);
                    });
                  }
                }
              }).finally(() => {
                this.cdr.detectChanges();
              });
        }

    }

    typoSuggestion(){

        // Greek content might not return results in suggestion title_autocomplete due to emphasis on greek letters.
        // Considering that we need a typo suggestion.
        var searchRequest = {
            "query": {
                "keyphrase": this.keyphrase
            },
            "suggestion": [
                {
                    "name": "keyword_typo"
                }
            ]                            
        };


        this.searchService.search(searchRequest, this.language).then(resp => {
            if (resp.status === 200) {
                // console.log(resp.data);
                if((resp.data as any)?.widgets[0]?.suggestion?.keyword_typo?.length > 0){
                    this.suggestions = (resp.data as any)?.widgets[0]?.suggestion?.keyword_typo?.map((suggestion : any) => suggestion);
                }
            }
        });
    }

    publishEvent(targetPageId:string){

        this.searchService.clickEventPublish(this.language, this.router.url, targetPageId, this.keyphrase).then(resp => {
            if (resp.status === 200) {
                // console.log(resp.data);
            }
        });
    }

    searchBranches(){
        this.branchesData=[];
        if (keyphraseVariants.has(this.keyphrase.trim())) {
            return;
        }
        var searchRequest = {
            "content": {},
            "personalization": {
                "fields": [
                    "heading1",
                    "name"
                ],
                "algorithm": "affinity"
            },
            "query": {
                "keyphrase": this.keyphrase
            }, 
            "filter": {
                "name": "type",
                "type": "eq",
                "value": "branch"
            },
            "limit":4,
            "offset":0
        };
    
        this.searchService.search(searchRequest, this.language).then(resp => {
            if (resp.status === 200) {
                this.searchQAResults=[];
                if((resp.data as any)?.widgets[0]?.content?.length > 0){
                    (resp.data as any)?.widgets[0]?.content.forEach((branch:any) => {
                        this.branchesData.push({
                            name: branch?.heading1,
                            code: branch?.description.split("@@")[0],
                            address: branch?.description.split("@@")[1],
                            workinghours: branch?.description.split("@@")[2],
                            lat: +branch?.description.split("@@")[3],
                            long: +branch?.description.split("@@")[4],
                            url : branch?.url
                        });
                    });
                    this.noResultsFound = false;
                }
            }
        }).finally(() => {
            if(this.searchResults.length > 0 && this.branchesData.length > 0 && this.isMobile){
                this.selectedDisplayedContent='content' ;
            }
            if(this.searchResults.length == 0 && this.branchesData.length == 0){
                this.noResultsFound = true;
            }
            this.cdr.detectChanges();

        });
    }

    getGoogleMapsLink(branch: BranchesData){
        const baseUrl = "https://www.google.com/maps/dir/?api=1";
        const destination = `&destination=${branch?.lat},${branch?.long}`;
        const travelMode = "&travelmode=driving"; // You can change this to walking, bicycling, or transit
        var mapsLink = `${baseUrl}${destination}${travelMode}`;
        return mapsLink;
    }

    changeDisplayedContent(text: string){
        this.selectedDisplayedContent = text;
        this.cdr.detectChanges();

    }
}
